import React from "react";
import { Button, Box, Typography, Grid, Paper } from "@mui/material";

const PricingPackages = () => {
  return (
    <Box display="flex" flexDirection="column" alignItems="center" p={4}>
      <Typography variant="h4" fontWeight="bold" textAlign="center" gutterBottom>
        Digital Invitation Card Package
      </Typography>
      <Typography variant="subtitle1" textAlign="center" mb={4}>
        Get the perfect digital invitation card to celebrate your special day with loved ones! 💌✨
      </Typography>

      <Grid container spacing={4} alignItems="center" justifyContent="center" maxWidth="lg">
        {/* Basic Package */}
        <Grid item xs={12} sm={6} md={4} display="flex" justifyContent="center">
          <Paper elevation={3} sx={{ padding: 3, borderRadius: 2, border: "4px solid red", textAlign: "center", width: "100%", maxWidth: 300 }}>
            <Typography variant="h5" fontWeight="bold">Basic</Typography>
            <Typography variant="h6">FREE</Typography>
            <Typography>📞 Contact</Typography>
            <Typography>📍 Location</Typography>
            <Typography>📅 Calendar</Typography>
            <Typography>🎵 Music</Typography>
            <Typography>💬 Guestbook</Typography>
            <Typography>⏳ Event Countdown</Typography>
            <Typography>🎨 Customizable Designs</Typography>
            <Button variant="contained" color="error" sx={{ mt: 2 }}>Preview</Button>
          </Paper>
        </Grid>

        {/* Standard Package */}
        <Grid item xs={12} sm={6} md={4} display="flex" justifyContent="center">
          <Paper elevation={3} sx={{ padding: 3, borderRadius: 2, border: "4px solid skyblue", textAlign: "center", width: "100%", maxWidth: 300 }}>
            <Typography variant="h5" fontWeight="bold">Standard</Typography>
            <Typography variant="h6" sx={{ textDecoration: "line-through" }}>RM30</Typography>
            <Typography variant="h6">RM10</Typography>
            <Typography>📦 All in Basic Package</Typography>
            <Typography>✅ RSVP</Typography>
            <Typography>💰 Money Gift</Typography>
            <Button variant="contained" color="primary" sx={{ mt: 2 }}>Preview</Button>
          </Paper>
        </Grid>

        {/* Premium Package */}
        <Grid item xs={12} sm={6} md={4} display="flex" justifyContent="center">
          <Paper elevation={3} sx={{ padding: 3, borderRadius: 2, border: "4px solid purple", textAlign: "center", width: "100%", maxWidth: 300 }}>
            <Typography variant="h5" fontWeight="bold">Premium</Typography>
            <Typography variant="h6" sx={{ textDecoration: "line-through" }}>RM60</Typography>
            <Typography variant="h6">RM30</Typography>
            <Typography>📦 All in Basic Package</Typography>
            <Typography>✅ RSVP</Typography>
            <Typography>💰 Money Gift</Typography>
            <Typography>📄 PDF Version</Typography>
            <Typography>✨ Premium Design</Typography>
            <Button variant="contained" color="secondary" sx={{ mt: 2 }}>Preview</Button>
          </Paper>
        </Grid>
      </Grid>

      {/* Call to Action */}
      <Box mt={4}>
        <Button variant="contained" color="primary" sx={{ fontSize: "1rem", padding: "10px 20px" }}>Get Yours Now!</Button>
      </Box>
    </Box>
  );
};

export default PricingPackages;